import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=7c6406c6&scoped=true"
import script from "./top-header.vue?vue&type=script&lang=js"
export * from "./top-header.vue?vue&type=script&lang=js"
import style0 from "./top-header.vue?vue&type=style&index=0&id=7c6406c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6406c6",
  null
  
)

export default component.exports